import jQuery from 'jquery';

// Preloader 
jQuery(window).on('load', function() {
    jQuery("#status").fadeOut(2000);
    jQuery("#preloader").delay(1800).fadeOut("slow");
});

